export default __webpack_public_path__ + "static/media/QR Code.63d81bba.svg";